window.terms = []

jQuery(function ($) {
  var canBeLoaded = true // this param allows to initiate the AJAX call only if necessary

  window.fields = []
  window.terms = []

  // Set the select based on URL
  setSelects() 

  $('.selectric-filter-tax').bind('change', function (event) {
    var _this = $(event.target)
    
    var tax = _this.attr('data-taxonomy')
    var tax_slug = ''

    var field = _this.attr('data-field')
    var field_value = ''

    if(tax){
      tax_slug = event.target.value
      filterByValue(_this, tax, tax_slug)
    } else if(field) {
      field_value = event.target.value
      filterByValue(_this, field, field_value, true)
    }

  })


  function filterByValue(_this, item_name, item_value, is_field = false){

    var grid = $('.grid-items') // Grid where add new items
    var _filters = _this.parents('.filters-section')

    // Clean search field
    $('.search-input').val('')

    if(is_field){
      window.fields = setFilters(window.fields, item_name, item_value)
    } else {
      window.terms = setFilters(window.terms, item_name, item_value)  //[...items]
    }

    // Update Url
    let searchString = '?'
    if(window.terms && window.terms.length > 0) {
      window.terms.some(item => {
        searchString += item.name + '=' + item.value + '&'
      })
    }

    if(window.fields && window.fields.length > 0) {
      window.fields.some(item => {
        searchString += item.name + '-field=' + item.value + '&'
      })
    }
    searchString = searchString.slice(0, searchString.length -1)
    const urlPath = window.location.origin +  window.location.pathname + searchString
    window.history.pushState(null, '', urlPath);

    // Disable programs
    $('.flagship-program').each(function(){
      if(window.terms.length === 0){
        $(this).removeClass('inactive')
      } else {
        window.terms.some(term => {
          if($(this).hasClass('tax-'+term.value)){
            $(this).removeClass('inactive')
          } else {
            $(this).addClass('inactive')
          }
        })
      }
    })

    var data = {
      action: 'loadmore',
      post_type: _filters.attr('data-posts'),
      partial: _filters.attr('data-partial'),
      items: _filters.attr('data-items'), // Columns
      post_not_in: _filters.attr('data-exclude'),
      page: _filters.attr('data-page'),
      year: _this.attr('data-year'), // In archives
      terms: JSON.stringify(window.terms),
      fields: JSON.stringify(window.fields),
      order_by: _filters.attr('data-order'),
    }

    if (canBeLoaded == true) {
      $.ajax({
        type: 'POST',
        url: loadmore_params.ajaxurl,
        data: data,
        beforeSend: function (xhr) {
          // you can also add your own preloader here
          // you see, the AJAX call is in process, we shouldn't run it again until complete
          _this.attr('disabled', true)
          canBeLoaded = false
          grid.empty()
          $('.no-results').hide()
          grid.append('<div class="loading-content text-center col-12 section-padding"><div class="spinner-grow" role="status"></div></div>')
        },
        success: function (results) {
          results = JSON.parse(results)
          grid.empty() // empty container

          if (results && results.total > 0) {
            $('.no-results').hide()
            // Replace new items
            grid.append(results.html) // where to insert posts

            // Set the year in the url
            if (data.year) {
              var params = '?y=' + data.year
              var new_URL =
                window.location.origin + window.location.pathname + params
              window.history.replaceState({}, data.year, new_URL)
            }
            canBeLoaded = true // the ajax is completed, now we can run it again
            // set load more BTN
            setLoadMore(results.total, data)
          } else {
            $('.no-results').show()
            setLoadMore(results.total, data)
            canBeLoaded = true // the ajax is completed, now we can run it again
          }
        },
        error: function (error) {
          console.log('error')
          console.log(error)
        },
        complete: function () {
          _this.attr('disabled', false)
        },
      })
    }
  }


  function setLoadMore(total, data) {
    total = parseInt(total)
    var load_more = $('.js-load-more')
    var grid = $('.grid-items') // Grid where add new items

    // Load more btn
    if (grid.children().length === total || grid.children().length === 0) {
      load_more.hide() // Hide button if there is no more elements
      load_more.parent().addClass('mt-n3') // Add negative margin to parent button
    } else {
      load_more.show() // Show button
      load_more.parent().removeClass('mt-n3') // Remove negative margin to parent button
    }

    var start_page = load_more.attr('data-startpage')
    load_more.attr('data-tot', total)
    load_more.attr('data-page', start_page)
    load_more.attr('data-time', data.time)
    load_more.attr('data-terms', data.terms)
  }


  function parseURLParams(url) {
    var queryStart = url.indexOf("?") + 1,
        queryEnd   = url.indexOf("#") + 1 || url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        pairs = query.replace(/\+/g, " ").split("&"),
        parms = [], i, n, v, nv;
  
    if (query === url || query === "") return;
  
    for (i = 0; i < pairs.length; i++) {
        nv = pairs[i].split("=", 2);
        n = decodeURIComponent(nv[0]);
        v = decodeURIComponent(nv[1]);
  
        // if (!parms.hasOwnProperty(n)) parms[n] = [];
        // parms[n].push(nv.length === 2 ? v : null);
        parms.push(
          {
            param: n,
            value: v
          }
        )
    }
    return parms;
  }
  
  function setSelects() {
    let filtersUrl =  parseURLParams(window.location.href)
    let filterParam = ''
    let filterValue = ''
    let isField = false

    if(filtersUrl){
      filtersUrl.some((filter) => {
        isField = filter.param.indexOf('field') > 0
        filterParam = filter.param.replace('-field', '')
        const items = isField ? window.fields : window.terms

        // Update selectric
        if(filter.value !== 'undefined'){
          $('#select-' + filterParam).val(filter.value).change().selectric('refresh');
          setFilters(items, filterParam, filter.value)
          filterValue = filter.value
        }
      })
      
      // Call the filter function just once
      if(filterValue) filterByValue($('.selectric-'+filterParam), filterParam, filterValue, isField)
    }
  }

  function setFilters(items, item_name, item_value){
    let indexItem = null

    if(items && items.length > 0){
      items.some((item, index) => {
        if(item.name === item_name) {
          indexItem = index 
          return true
        } else {
          indexItem = index + 1
        }  
      })
    }
 
    if(indexItem !== null){
      items[indexItem] = {
        name: item_name,
        value: item_value,
      }
    } else {
      items.push({
        name: item_name,
        value: item_value,
      })
    }

    // If All -> remove the taxonomy from the array
    if(item_value == 'all'){
      items = items.filter((item, index) => {
        return item.name != item_name
      })
    }

    return items
 
  }
  

})


  


